const data = {
  regions:null
}

const set = (regions) => {
  data.regions = regions
}

const get = () => {
  return data.regions
}

const getTitle = (code, language) => {
  let region = (data.regions || []).find(r => r.code.toUpperCase() === code.toUpperCase())
  return region ? region.title[language] : 'Schweiz'
}

export default {set, get, getTitle}